import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import {
  getDriveControlFromDriveControlTag,
  getDriveControls,
} from '../../../helpers/driveControl';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { mapOptionsOrder } from '../../../helpers/optionsSort';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  driveControl: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (driveControl, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      driveControl,
      // Unset add-on products in case selected previously via a different drive control
      powerSupply: undefined,
      remoteControl: undefined,
      liftPosition: undefined,
      extensionPole: undefined,
      measureInsurancePrice: 0,
      fasciaPrice: 0,
      smartReleasePrice: 0,
      lightGuardPrice: 0,
      venetianValancePrice: 0,
      trackPrice: 0,
      extensionPolePrice: 0,
      dynamicPrice: 0,
      stainlessSteelChainPrice: 0,
    },
  });

export const DriveControl = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    custom: { driveControl },
  } = state.context;

  const driveControlOptions = getDriveControls(state.context);
  const productType = getBaseProductType(state.context);
  if (
    isCurrentState('driveControl', state) &&
    driveControlOptions.length === 0
  ) {
    throwError(state);
  }

  const driveControlOrder = [
    'Drive Control: Cordless',
    'Drive Control: Chainless',
    'Drive Control: Smartglide',
    'Drive Control: Chain',
    'Drive Control: Corded',
    'Drive Control: Cordloop',
  ];
  let sortedDriveControl = mapOptionsOrder(
    driveControlOptions,
    driveControlOrder,
  );

  return (
    <SectionContent>
      <Heading>Drive Control</Heading>
      <Caption>How would you like to operate your blind?</Caption>
      <Selector
        isSlider={true}
        isSingleOption={driveControlOptions.length === 1 ? true : false}
      >
        {sortedDriveControl.map(option => {
          let title = getDriveControlFromDriveControlTag(option);
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'driveControl',
            title,
          );
          return (
            <>
              <SelectorImageItem
                isSelected={driveControl === option}
                onClick={onClick(option, send)}
                showIcon={showIcon}
                Icon={Icon}
                title={
                  productType === 'Roller Blind' &&
                    option === 'Drive Control: Smartglide'
                    ? 'Cordless'
                    : title
                }
                key={option}
                description={description}
              />
            </>
          );
        })}
      </Selector>
    </SectionContent>
  );
};
